export const getMenuParentElements = (menu) => {
  if (!Array.isArray(menu)) {
    return [];
  }
  const menuParentElements = menu.filter(
    (item) => item.menu_item_parent === "0",
  );
  return menuParentElements;
};

export const menuHasChildren = (menu, parentId) => {
  const menuChildren = menu.filter(
    (item) => item.menu_item_parent === `${parentId}`,
  );
  return menuChildren.length > 0;
};
/**
 * Get parent menu children
 * @name getParentMenuChildren
 * @param {array} menu
 * @param {string} parent id
 * @return {array} menu children
 */
export const getParentMenuChildren = (menu, parent) => {
  if (!Array.isArray(menu)) {
    return {
      menuChildren: [],
      menuChildrenWithChildren: [],
      menuHasNoGrandChildren: true,
    };
  }
  const menuChildren = menu
    .filter((item) => item.menu_item_parent === `${parent}`)
    .filter(
      (item) =>
        // if item has children, remove it from the list because we want to show those in different column
        !menuHasChildren(menu, item.ID),
    );
  // These are basically "Tuotteet" menu items (but menu can have multiple child items with children and it still should look okay)
  const menuChildrenWithChildren = menu
    .filter((item) => item.menu_item_parent === `${parent}`)
    .map((item) => {
      const children = menu.filter(
        (child) => child.menu_item_parent === `${item.ID}`,
      );
      if (children.length === 0) {
        return null;
      }
      return {
        ...item,
        children,
      };
    })
    .filter((item) => !!item);
  return {
    menuChildren,
    menuChildrenWithChildren,
    // menuHasNoGrandChildren basically means that this is a contact menu ("Muotolevy") and it shouldn't have "grandchildren" items (sub-submenus)
    // NOTE: "contact menu" needs to be the last menu item in the wp-menu ('site-megamenu')
    menuHasNoGrandChildren: menuChildrenWithChildren.length <= 0,
  };
};

export const toggleCookieSettings = () => {
  // eslint-disable-next-line no-undef
  const overlay = document.querySelector(".cboverlay");
  if (overlay) {
    overlay.classList.toggle("visible");
  }
};
